// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/router'
import ElementUI, {Message} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import Print from 'vue-print-nb';

import * as echarts from 'echarts';

/** 全局弹窗拖拽指令 */
import dialogDrag from './directives/dialogDrag';

/**导入iconfont*/
import './assets/iconfont/iconfont.css';

/** 导入全局样式 */
import './assets/css/global.css'


/** 导入全局axios*/
import axios from 'axios'
axios.defaults.baseURL='/api/v1'
Vue.prototype.$http=axios
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Print);
Vue.directive('dialogDrag', dialogDrag);

// Vue.component('ECharts', echarts);

// 在请求头中加token
axios.interceptors.request.use(
  config => {
    // 判断是否存在token，若是存在的话，则每一个http header都加上token
    const token = window.sessionStorage.getItem('token')
    if (token) {
      // config.headers.Authorization = token;
      config.headers.token = token;
    }
    return config;
  });
//响应拦截
axios.interceptors.response.use(function (response) {
  return response
}, async function (error) {
  if (error.response.status === 401){
     Message.error("令牌已失效，请重新登录");
     await router.push('/login');
  }
  return false;
});




/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js